export const IOS = 1

export const ANDROID = 2
